import React, { useEffect, useState } from 'react';
import ClientCheckListGenetator from '../clientchecklist/generalinfo/generalinfo';
import ProgressNav from '../progressNav';
import { useHistory } from 'react-router';
import Footer from '../clientchecklist/footer';
import ClientBankDetailsGenerator from '../clientchecklist/bankdetails/bankdetails';
import DifferentSource from '../clientchecklist/differentSource/differentSource';
import ClientIncomeTaxPassword from '../clientchecklist/incometaxpassword/incometaxpassword';
import ClientTravelOutsideIndia from '../clientchecklist/traveloutsideindia/traveloutsideindia';
import DirectorInCompany from '../clientchecklist/directorincompany/directorincompany';
import ClientTotalIncome from '../clientchecklist/totalincome/totalincome';
import ClientForeignAssets from '../clientchecklist/foreignassets/index';
import ClientAddAdditional from '../../checkListGenerator/clientchecklist/clientAddAdditional/index';
import { compose } from 'redux';
import SalaryDifferentSource from './differentSource/salary';
import { userType } from '../../../config/usertypeValue';
import TabList from '../../../components/checklistTab/tabList';

export default function ClientChecklistHome(props) {
    const [pageNo, setPageNo] = useState(1);
    const [subPage, setSubPage] = useState(0);
    const [subPgVal, setSubPgVal] = useState(3.0);

    const history = useHistory();

    // const handlePage = (pageNo) => {
    //         setPageNo(pageNo);
    //     }
    const handlePage = (pageNo) => {

        setPageNo(pageNo);
        window.scrollTo(0, 0);
    }


    const handleSubPage = (subPage) => {
        setSubPage(subPage);
    };
    //console.log("Page Number After Home", pageNo);

    // const navigateChecklist = () => {
    //     history.push('/menu/crc-checklist');
    // }

    const navigateChecklist = (path, typeValue) => {
        // userType.value = typeValue;
        // history.push(path);
    }

    return (
        <>
            {/* <div className="stage-indicator">
                <ul>
                    <ul>
                        <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')}>L1 Checklist</li>
                        <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')}>L1 CRC Confirmed</li>
                        <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} >L1 AM Confirmed</li>
                        <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className="active">EM Confirmed</li>
                    </ul>
                </ul>
            </div> */}
            {/* <h1> hi Ravi </h1> */}
            <TabList />
            <ProgressNav pageNo={pageNo} handlePageChange={handlePage} />
            {pageNo === 1 && <ClientCheckListGenetator handlePageChange={handlePage} />}
            {pageNo === 2 && <ClientBankDetailsGenerator handlePageChange={handlePage} />}
            {pageNo === 3 && <DifferentSource handlePageChange={handlePage} />}
            {pageNo === 4 && <ClientIncomeTaxPassword handlePageChange={handlePage} />}
            {pageNo === 5 && <ClientTravelOutsideIndia handlePageChange={handlePage} />}
            {pageNo === 6 && <DirectorInCompany handlePageChange={handlePage} />}
            {pageNo === 7 && <ClientForeignAssets handlePageChange={handlePage} />}
            {pageNo === 8 && <ClientTotalIncome handlePageChange={handlePage} />}
            {pageNo === 9 && <ClientAddAdditional handlePageChange={handlePage} />}
            {/* <Footer pageNo={pageNo} handlePageChange={handlePage} handleSubPage={handleSubPage}/> */}
        </>
    );
}
